import { useLayoutEffect } from "react";

function useBodyClassName(...classList) {
	useLayoutEffect(() => {
		// Empty array is a noop.
		if (!classList.length) {
			return () => {};
		}

		document.body.classList.add(...classList);
		return () => document.body.classList.remove(...classList);
	}, [classList]);
}

export default useBodyClassName;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useBodyClassName.js